import {
  ProjectVisibilityType,
  ProjectWorkUnit,
  BillingFlagsOptionsDescriptions,
  ExposedBillingFlagsOptionsType,
  LanguageCode,
} from '@scale/shared/types/projectParameterGroup';

export const PROJECT_BILLING_TYPE_OPTIONS = [
  {
    id: ProjectVisibilityType.Customer,
    name: `Going to Customer - Paid production or paid pilot project`,
  },
  {
    id: ProjectVisibilityType.UnpaidPilot,
    name: `Going to Customer - Unpaid pilot`,
  },
  {
    id: ProjectVisibilityType.DataStreams,
    name: `Going to Customer - Data streams project`,
  },
  {
    id: ProjectVisibilityType.InternalForCustomer,
    name: `Going to Customer - Internal project for customer`,
  },
  {
    id: ProjectVisibilityType.Linked,
    name: `Going to Linked project for further processing before delivering to customer`,
  },
  {
    id: ProjectVisibilityType.Forecast,
    name: `Does not produce data - forecast project`,
  },
  {
    id: ProjectVisibilityType.Internal,
    name: `Data does not go to an external customer - internal test project`,
  },
];

export const PROJECT_WORK_UNIT_OPTIONS = [
  {
    id: ProjectWorkUnit.Task,
    name: 'Task-based billing',
  },
  {
    id: ProjectWorkUnit.Hour,
    name: 'Hourly billing',
  },
  {
    id: ProjectWorkUnit.Model,
    name: 'Model-based billing',
  },
];

export const BILLING_FLAG_OPTIONS = Object.keys(BillingFlagsOptionsDescriptions).map(key => ({
  id: key,
  value: BillingFlagsOptionsDescriptions[key as ExposedBillingFlagsOptionsType].name,
}));

export const PROJECT_BILLING_PILOT_TYPES = [
  ProjectVisibilityType.Customer,
  ProjectVisibilityType.UnpaidPilot,
];

export const LANGUAGE_CODE_OPTIONS = [...Object.values(LanguageCode)].map(l => ({
  id: l,
  name: l,
}));
